import * as Sentry from '@sentry/react';

import { BUILD_DATE, BUILD_NUMBER, ENV, SENTRY_KEY } from 'settings';

let ravenSetup = false;

if (SENTRY_KEY) {
  Sentry.init({
    beforeSend(event) {
      const ignoreErrors = event.exception.values.every((err: any) => !err || err.ignoreLog || err.isAxiosError);
      if (ignoreErrors) {
        return null;
      }
      if (event.transaction && event.transaction.includes('tawk.to')) {
        return null;
      }
      if (!window.location.href.startsWith('https://')) {
        return null;
      }
      return event;
    },
    dsn: SENTRY_KEY,
    environment: ENV,
    release: BUILD_NUMBER,
    ignoreErrors: [
      'Network Error',
      'Request aborted',
      /Request failed with status code .*/,
      'timeout of 0ms exceeded',
      'SecurityError: The operation is insecure.',
      'ResizeObserver loop limit exceeded',
      'NS_ERROR_NOT_INITIALIZED',
      `can't redefine non-configurable property "userAgent"`,
      /Non-Error promise rejection captured with value: Object Not Found Matching Id.*/
    ],
    denyUrls: [/https:\/\/\w+\.eduzz\.com/],
    allowUrls: [/https:\/\/\w+\.nutror\.com/, /https?:\/\/\w+\.devzz\.ninja/]
  });
  Sentry.setTags({
    version: BUILD_NUMBER,
    versionDate: BUILD_DATE
  });

  ravenSetup = true;
}

export function addBreadcrumb(message: string, category: string = 'manual', data: any = {}): void {
  data = data || {};
  delete data.type;

  if (ravenSetup) {
    Sentry.addBreadcrumb({ message, category, data });
  }
}

export function logError(err: any): void {
  if (ravenSetup) {
    Sentry.captureException(err, { extra: err.extraData });
  }
}
